(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = createAcl

function createAcl (acl) {

  function allowed (targets, resource, action) {

    var target
    if (!Array.isArray(targets)) targets = [ targets ]

    for (var i = 0; i < targets.length; i++) {

      target = targets[i]

      // Allow wildcard resource. This allows you to create a target with
      //    grant('root', '*', '*')
      // Who will always have access
      if (acl['*'].actions['*'].indexOf(target) !== -1) return true
      if (targetAllowed(target, resource, action)) return true

    }

    return false

  }

  function targetAllowed (target, resource, action) {
    return acl[resource]
        && acl[resource].actions[action]
        && ((acl[resource].actions[action].indexOf(target) !== -1)
        || (acl[resource].actions['*'] && acl[resource].actions['*'].indexOf(target) !== -1))
  }

  return { allowed: allowed, acl: acl }

}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/acl.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL2FjbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJtb2R1bGUuZXhwb3J0cyA9IGNyZWF0ZUFjbFxuXG5mdW5jdGlvbiBjcmVhdGVBY2wgKGFjbCkge1xuXG4gIGZ1bmN0aW9uIGFsbG93ZWQgKHRhcmdldHMsIHJlc291cmNlLCBhY3Rpb24pIHtcblxuICAgIHZhciB0YXJnZXRcbiAgICBpZiAoIUFycmF5LmlzQXJyYXkodGFyZ2V0cykpIHRhcmdldHMgPSBbIHRhcmdldHMgXVxuXG4gICAgZm9yICh2YXIgaSA9IDA7IGkgPCB0YXJnZXRzLmxlbmd0aDsgaSsrKSB7XG5cbiAgICAgIHRhcmdldCA9IHRhcmdldHNbaV1cblxuICAgICAgLy8gQWxsb3cgd2lsZGNhcmQgcmVzb3VyY2UuIFRoaXMgYWxsb3dzIHlvdSB0byBjcmVhdGUgYSB0YXJnZXQgd2l0aFxuICAgICAgLy8gICAgZ3JhbnQoJ3Jvb3QnLCAnKicsICcqJylcbiAgICAgIC8vIFdobyB3aWxsIGFsd2F5cyBoYXZlIGFjY2Vzc1xuICAgICAgaWYgKGFjbFsnKiddLmFjdGlvbnNbJyonXS5pbmRleE9mKHRhcmdldCkgIT09IC0xKSByZXR1cm4gdHJ1ZVxuICAgICAgaWYgKHRhcmdldEFsbG93ZWQodGFyZ2V0LCByZXNvdXJjZSwgYWN0aW9uKSkgcmV0dXJuIHRydWVcblxuICAgIH1cblxuICAgIHJldHVybiBmYWxzZVxuXG4gIH1cblxuICBmdW5jdGlvbiB0YXJnZXRBbGxvd2VkICh0YXJnZXQsIHJlc291cmNlLCBhY3Rpb24pIHtcbiAgICByZXR1cm4gYWNsW3Jlc291cmNlXVxuICAgICAgICAmJiBhY2xbcmVzb3VyY2VdLmFjdGlvbnNbYWN0aW9uXVxuICAgICAgICAmJiAoKGFjbFtyZXNvdXJjZV0uYWN0aW9uc1thY3Rpb25dLmluZGV4T2YodGFyZ2V0KSAhPT0gLTEpXG4gICAgICAgIHx8IChhY2xbcmVzb3VyY2VdLmFjdGlvbnNbJyonXSAmJiBhY2xbcmVzb3VyY2VdLmFjdGlvbnNbJyonXS5pbmRleE9mKHRhcmdldCkgIT09IC0xKSlcbiAgfVxuXG4gIHJldHVybiB7IGFsbG93ZWQ6IGFsbG93ZWQsIGFjbDogYWNsIH1cblxufVxuIl19